import { createAction, props } from "@ngrx/store";

export const UpdateHelpStoreAction = "[help] Update Help Store";
export const UpdateHelpStoreSuccessAction = "[help] Update Help Store Success";

export const UpdateHelpStore = createAction(UpdateHelpStoreAction, props<{ action: string }>());
export const UpdateHelpStoreSuccess = createAction(UpdateHelpStoreSuccessAction, props<{ action: string }>());